import React from "react";

const ShowOn: React.FC<{ color?: string }> = ({ color = "#121C2D" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
  >
    <path
      d="M1.5 10s3.5-5.5 8.5-5.5S18.5 10 18.5 10s-3.5 5.5-8.5 5.5S1.5 10 1.5 10Z"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />
    <circle
      cx="10"
      cy="10"
      r="2.75"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
    />
  </svg>
);

export default ShowOn;
